import { useRef, useEffect } from 'react';

/**
 * FloatingParticlesBg — 漂浮颗粒层
 * 25 个青蓝微粒极慢上升
 */
export default function FloatingParticlesBg() {
  const containerRef = useRef(null);
  const particlesRef = useRef([]);
  const animRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const W = container.offsetWidth || 1200;
    const H = container.offsetHeight || 800;

    particlesRef.current = Array.from({ length: 25 }, () => ({
      x: Math.random() * W,
      y: Math.random() * H,
      size: 1.5 + Math.random() * 2.5,
      speed: 0.15 + Math.random() * 0.3,
      opacity: 0.06 + Math.random() * 0.18,
      phase: Math.random() * Math.PI * 2,
      driftSpeed: 0.3 + Math.random() * 0.5,
      driftAmp: 4 + Math.random() * 8,
    }));

    let lastTime = performance.now();

    const tick = (now) => {
      const dt = Math.min((now - lastTime) / 16.67, 3);
      lastTime = now;
      const h = container.offsetHeight || 800;
      const w = container.offsetWidth || 1200;
      const nodes = container.children;

      particlesRef.current.forEach((p, i) => {
        p.y -= p.speed * dt;
        p.x += Math.sin(now * 0.001 * p.driftSpeed + p.phase) * p.driftAmp * dt * 0.04;

        if (p.y < -10) {
          p.y = h + 10;
          p.x = Math.random() * w;
        }

        const node = nodes[i];
        if (node) {
          node.style.transform = `translate3d(${p.x}px, ${p.y}px, 0)`;
          node.style.opacity = p.opacity;
        }
      });

      animRef.current = requestAnimationFrame(tick);
    };

    animRef.current = requestAnimationFrame(tick);
    return () => { if (animRef.current) cancelAnimationFrame(animRef.current); };
  }, []);

  return (
    <div ref={containerRef} className="absolute inset-0 overflow-hidden" style={{ opacity: 0.8 }}>
      {Array.from({ length: 25 }).map((_, i) => (
        <div
          key={i}
          className="absolute rounded-full will-change-transform"
          style={{
            width: `${2 + (i % 3)}px`,
            height: `${2 + (i % 3)}px`,
            background: 'radial-gradient(circle, rgba(120, 200, 240, 0.6) 0%, rgba(88, 183, 232, 0) 70%)',
            boxShadow: '0 0 3px rgba(120, 200, 240, 0.25)',
          }}
        />
      ))}
    </div>
  );
}
